// STYLE IMPORT
import '../less/app.less'

// MAIN LIBS
import 'promise-polyfill/src/polyfill';
import localforage from 'localforage'
import moment from 'moment'
import axios from 'axios'
import swal from 'sweetalert2'
import _ from 'lodash'
import 'hammer-timejs'
import config from './config';
// VUE JS IMPORT & INIT
import Vue from 'vue'
import VueRouter from 'vue-router'
// CUSTOM ROUTER
import router from './routes'
// GLOBAL COMPONENTS
import MainLayout from '../components/Layout.vue'
import AppHeader from '../components/common/Header.vue'
import ActionBar from '../components/common/ActionBar.vue'
import FilterBar from '../components/common/FilterBar.vue'
// IMPORT CLASS FOR FUNCTION SCAN
import OperationBouteille from './models/OperationBouteille'
import Bouteille from './models/Bouteille'
import Scan from './models/Scan'
import Asynchro from "./core/Asynchro";
import { estSessionExpiree } from "./core/SessionExpiree";
import L from 'leaflet';

//En Français c'est mieux !
moment.locale('fr');

window.localforage = localforage;
window.moment = moment;
window.axios = axios;
window.swal = swal;
window._ = _;
window.L = L;

window.urlAPI = config.urlAPI;

// Nettoyage des caches de la fonctionnalité Agenda / Planning, supprimée côté
// serveur (MD-463) puis côté application (MD-667). Sans ça, ces clés
// resteraient indéfiniment dans IndexedDB sur les téléphones déjà installés.
// Idempotent, sans effet sur les autres caches ni sur la file d'actions
// hors-ligne : un échec ne doit jamais empêcher l'application de démarrer.
['listEvents', 'parameters'].forEach(function (cle) {
    localforage.removeItem(cle).catch(function (err) {
        console.warn('Nettoyage du cache obsolète impossible : ' + cle, err);
    });
});

//Worker
if ('serviceWorker' in navigator) {
    try {
        if (process.env.NODE_ENV === 'production') {
            const OfflineRuntime = require('offline-plugin/runtime');
            OfflineRuntime.install({
                // Pas de rechargement en cours de saisie : la nouvelle version s'applique à la prochaine ouverture.
                onUpdateReady: () => OfflineRuntime.applyUpdate()
            });
        } else {
            // En dev offline-plugin n'est pas actif : le worker reste nécessaire au chargement des OTAG et détenteurs.
            navigator.serviceWorker.register(require("!!file-loader?name=[name].[hash].js!@/js/core/Worker.js"));
        }

        new BroadcastChannel('fi360-sw').onmessage = function(event) {
            Asynchro.workerData(event.data);
        };
    } catch (err) {
        // Catch any errors from the require statement or other synchronous code
        console.warn('An error occurred while setting up the service worker:', err);
    }
} else {
    console.warn('Service Workers are not supported in this browser.');
}


Vue.use(VueRouter);

// Error reporting to Discord
let _lastErrorSent = 0;
function _sendErrorToDiscord(message, source, stack) {
    const now = Date.now();
    if (now - _lastErrorSent < 5000) return;
    _lastErrorSent = now;

    const domain = window.location.hostname;
    const page = window.hashValue || window.location.pathname;

    const _u = Vue.prototype.$user;
    const userInfo = _u
        ? 'User: `' + _u.id + '` ' + _u.first_name + ' ' + _u.last_name + ' | Opérateur: `' + (_u.operator ? _u.operator.id + '` ' + _u.operator.company : 'N/A`')
        : 'User: non connecté';
    const deviceInfo = navigator.userAgent;

    const content = '**[' + domain + ']** : Error JS : `' + page + '`\n' + userInfo + '\n`' + deviceInfo + '`\n```\n' + message + '\n' + (source ? 'Source: ' + source + '\n' : '') + (stack ? stack.substring(0, 1000) : '') + '\n```';

    fetch(config.discordWebhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content: content })
    }).catch(function() {});
}

// Bug WebKit iOS : au retour d'arrière-plan, IndexedDB (localforage) reste inutilisable jusqu'au
// rechargement. Un seul rechargement par minute : au-delà, l'erreur est remontée sur Discord.
let _rechargementIndexedDbDemande = false;
function _gererIndexedDbPerdue(err) {
    const message = String((err && err.message) || err);
    if (message.indexOf('Connection to Indexed Database server lost') === -1) return false;
    if (_rechargementIndexedDbDemande) return true;

    let dejaRecharge = true;
    try {
        dejaRecharge = Date.now() - (parseInt(sessionStorage.getItem('rechargementIndexedDb'), 10) || 0) < 60000;
        if (!dejaRecharge) sessionStorage.setItem('rechargementIndexedDb', String(Date.now()));
    } catch (e) {
        dejaRecharge = true;
    }
    if (dejaRecharge) return false;

    _rechargementIndexedDbDemande = true;
    swal({
        title: 'Redémarrage nécessaire',
        text: "Le stockage de l'appareil ne répond plus. L'application va redémarrer.",
        type: 'warning',
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then(window.wantReload, window.wantReload);
    return true;
}

Vue.config.errorHandler = function(err, vm, info) {
    if (estSessionExpiree(err)) return;
    if (_gererIndexedDbPerdue(err)) return;
    if (err instanceof Error) {
        _sendErrorToDiscord(err.message, info, err.stack);
    } else {
        _sendErrorToDiscord(String(err), info, '');
    }
};

window.onerror = function(message, source, lineno, colno, error) {
    if (_gererIndexedDbPerdue(message)) return false;
    // Erreur masquée par le navigateur (script cross-origin ou injecté, ex. Brave iOS) : aucune info exploitable
    if (message === 'Script error.' && !source) return false;
    _sendErrorToDiscord(message, source + ':' + lineno, error ? error.stack : '');
    return false;
};

window.addEventListener('unhandledrejection', function(event) {
    var err = event.reason;
    // Session expirée : déjà prise en charge par SessionExpiree (retour au login),
    // y compris le rejet d'Api.init() qui s'ensuit avant la redirection
    if (estSessionExpiree(err) || err === 'Pas connecté !') return;
    if (_gererIndexedDbPerdue(err)) return;
    // Hors-ligne ou réseau trop lent : attendu en offline-first. Un « Network Error » en ligne
    // (API down, CORS) reste remonté.
    if (err && err.isAxiosError && !err.response && (!navigator.onLine || /^timeout of \d+ms exceeded$/.test(err.message))) return;
    // Ignore GeolocationPositionError (user denied permission)
    if (err && typeof err === 'object' && 'code' in err && 'PERMISSION_DENIED' in err) return;
    // Ignore SweetAlert2 cancel/dismiss (cancel = bouton annuler, overlay = clic dehors, esc = touche échap, timer = fermeture auto, close = croix)
    if (err === false || err === 'cancel' || err === 'overlay' || err === 'esc' || err === 'timer' || err === 'close' || (err && typeof err === 'object' && err.dismiss)) return;
    if (err instanceof Error) {
        _sendErrorToDiscord(err.message, '', err.stack);
    } else {
        _sendErrorToDiscord(String(err), '', '');
    }
});

// DATE GLOBAL FILTER
Vue.filter('dateFormat', function (val, format) {

    if(typeof format != "undefined"){
        return moment(val).format(format)
    }
    return moment(val).format('DD/MM/YYYY')
});

Vue.component('MainLayout', MainLayout);
Vue.component('AppHeader', AppHeader);
Vue.component('ActionBar', ActionBar);
Vue.component('FilterBar', FilterBar);

function triggerHashValueChangedEvent(value) {
    const event = new CustomEvent('hashValueChanged', { detail: value });
    window.dispatchEvent(event);
}

window.hashValue = '/login';

localforage.getItem('profil').then(profil => {
    Vue.prototype.$user = profil ? JSON.parse(profil) : null;

    const app = new Vue({
        router,
        data: {
            badgeCount: 0,
        },
        created() {
            this.$router.beforeEach((to, from, next) => {
                if (to.path !== from.path) {
                    window.hashValue = to.path;
                    triggerHashValueChangedEvent(window.hashValue);
                }
                next();
            });

            this.checkForNewResponses();
            setInterval(this.checkForNewResponses, 15000);
        },
        methods: {
            checkForNewResponses() {
                const user = this.$user;
                if (user && user.operator && user.operator.token) {
                    const url = `https://support.fi360.fr/public/unreads?token=${encodeURIComponent(user.operator.token)}&user=${user.id}`;

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            this.badgeCount = data.unreads;
                        })
                        .catch(error => console.error('Error checking for new responses:', error));
                }
            }
        }
    }).$mount('#app');
    // Expose root Vue instance globally for external handlers
    window.app = app;
});

window.isMobile = function() {
    const mobileKeywords = ['Android', 'iPhone', 'iPad', 'Mobile', 'Tablet'];
    return mobileKeywords.some(keyword => navigator.userAgent.includes(keyword));
}

window.wantReload = function() {
    if(window.isMobile() === true) {
        console.log('need_reload');
        if (typeof window.flutter_inappwebview !== 'undefined') {
            window.flutter_inappwebview.callHandler('handlerReload', true);
        } else {
            window.location.reload();
        }
    }else{
        window.location.reload();
    }
}

// FUNCTION TRIGGER PAR RECUPSCAN LORS D'UNE FIBSDD
window.scanForOp = async (otag) => {

    if(otag.indexOf('#id') > 0){
        otag = otag.split('#id')[1];
    }else if(otag.indexOf('://bouteille/') > 0){
        otag = otag.split('/bouteille/')[1];
    }


    // ON RECUP LA VAR DE LA WINDOW...
    let res = results;
    let opBoutObj = new OperationBouteille();

    return new Promise(async (resolve) => {
        let strValid = true;
        let tab = [];

        if (!_.includes(otag, '-')) {
            strValid = false
        } else {
            tab = otag.split('-');
            if (tab.length !== 2) {
                strValid = false
            }
        }

        let key1 = parseInt(tab[0]);
        let key2 = tab[1];

        if (strValid === true) {

            if (typeof res !== 'undefined') {

                if (res['bouteilles'].length !== 0) {

                    let findByKeys = _.find(res['bouteilles'], {key1, key2});
                    let findByOtag = _.find(res['bouteilles'], {"otag": key1 + '-' + key2});

                    if (findByKeys || findByOtag) {

                        let boutSelected = null;
                        if (findByKeys) {
                            boutSelected = findByKeys
                        } else if (findByOtag) {
                            boutSelected = findByOtag
                        }

                        if (boutSelected === null) {
                            await swal('Erreur', "Puce O-TAG non associée ou bouteille incompatible avec ce type d'opération", 'error');
                            return;
                        }

                        const _rawFluides = JSON.parse(await localforage.getItem('listFluides'));
                        const fluids = _rawFluides ? _rawFluides.noFiltre : [];
                        //Bouteille active ?
                        const isActive = boutSelected.actif;
                        //Bon type de bouteille pour le type d'opération ?
                        let typeOp = res['typeOp'];
                        const isTypeValid = typeOp.types.includes(boutSelected.type);

                        const isFluidValidFunction = () => {
                            if (typeOp.searchRegen) {
                                if (boutSelected.fluide !== null) {
                                    const fluid = fluids.find(f => f.id === typeOp.idFluide);
                                    const regenFluid = fluids.find(f => f.nom === `${fluid.nom} R`);
                                    return regenFluid && regenFluid.id === boutSelected.fluide.id;
                                }
                                return false;
                            } else {
                                return boutSelected.hasOwnProperty('fluide') &&
                                    boutSelected.fluide !== null &&
                                    boutSelected.fluide.id === typeOp.idFluide;
                            }
                        };

                        const isFluidValid = isFluidValidFunction();

                        const hasFluid = boutSelected.poids_net !== 0;
                        const isNotFull = boutSelected.poids_net !== boutSelected.poids_max;
                        let isOk = null;

                        if (typeOp.realType.includes('Ajout')) {
                            isOk = isFluidValid && hasFluid;
                        } else if (typeOp.realType.includes('Retrait')) {
                            isOk = isFluidValid || (boutSelected.hasOwnProperty('fluide') && boutSelected.type !== 'Fluide frigorigène') && isNotFull;
                        }

                        if(!isActive || !isTypeValid || !isOk) {
                            await swal('Erreur', "Puce O-TAG non associée ou bouteille incompatible avec ce type d'opération", 'error');
                            return;
                        }

                        const opObj = new OperationBouteille();
                        const ops = await opObj.getOpsForBouteille(boutSelected.id, false);

                        if (typeOp.realType.includes('recyclé') || typeOp.realType.includes('réutilisation')) {
                            for (const op of ops) {
                                if (op.id_type == 4) {
                                    isOk = false;
                                }
                            }
                        } else if (typeOp.realType.includes('traitement')) {
                            let balance = 0;
                            for (const op of ops) {
                                balance += op.id_type == 5 ? op.quantite : 0;
                                balance -= op.id_type == 2 ? op.quantite : 0;
                            }

                            balance = Math.round(balance * 1000) / 1000;

                            if (balance !== 0) {
                                isOk = false;
                            }
                        }

                        if(isOk === false) {
                            await swal('Erreur', "La bouteille est incompatible avec ce type d'opération", 'error');
                            return;
                        }


                        opBoutObj
                            .choiceQuantity(boutSelected)
                            // Appel via l'objet : createOperation() utilise `this`.
                            .then(quantite => opBoutObj.createOperation(quantite))
                            .then(op => opBoutObj.addOfflineOperation(op))
                            .then(op => {

                                Bouteille
                                    .applyOperation(op)
                                    .then(() => {

                                        if(!window.app || !window.app.$children || window.app.$children.length === 0) {
                                            resolve(op);
                                            return;
                                        }

                                        const root = window.app.$children[0];
                                        if(!root || !root.$children || root.$children.length === 0) {
                                            resolve(op);
                                            return;
                                        }

                                        let magicIndex = _.findIndex(root.$children[0].$children, child => {
                                            if (child.$el.id === 'manip-fluide') {
                                                return child
                                            }
                                        });

                                        if(magicIndex > -1) {
                                            const manip = root.$children[0].$children[magicIndex];
                                            if(manip && Array.isArray(manip.ops)) {
                                                manip.ops.push(op);
                                                const ops = manip.ops;
                                                manip.$emit('newManip', [ops]);
                                            }
                                        }

                                        resolve(op)

                                    })
                                    .catch()

                            })
                            .then(() => {
                                Scan.addOfflineScanBouteille(boutSelected.id)
                            })
                            .catch();
                    } else {
                        swal.close();
                        await swal('Erreur bouteille', "Puce O-TAG non associée ou bouteille incompatible avec ce type d'opération", 'warning')
                    }
                } else {
                    await swal('Erreur', "Puce O-TAG non associée ou bouteille incompatible avec ce type d'opération", 'error');
                }
            }


        }
    })
};

// FUNCTION TRIGGER PAR RECUPSCAN LORS D'UN AJOUT BOUTEILLE
window.tryGoTo = function (str, data = {}) {
    if(str.indexOf('#id') > 0){
        str = str.split('#id')[1];
    }else if(str.indexOf('://bouteille/') > 0){
        str = str.split('/bouteille/')[1];
    }

    swal.close();
    if(typeof data.bouteille !== 'undefined'){
        router.push({name: 'scan-otag', params: {str: str, bouteille : data.bouteille}})
    }else{
        router.push({name: 'scan-otag', params: {str: str}})

    }
};

window.tryGoToInstall = function (str, data = {}) {
    if(str.indexOf('#install') > 0) {
        str = str.split('#install')[1];
    }else if(str.indexOf('://installation/') > 0) {
        str = str.split('/installation/')[1];
    }else if(str.indexOf('bouteille.php#id') > 0 || str.indexOf('://bouteille/') > 0) {
        swal.close();
        swal({
            title: 'Oops',
            text: "Vous avez scanné une puce O-TAG bouteille, veuillez utiliser une puce O-TAG Install",
            type: 'warning',
        })
        return;
    }

    if(typeof data.idDet == 'undefined'){
        data.idDet = "0";
    }

    swal.close();
    if(typeof data.idInst !== 'undefined'){
        router.push( { name: 'scan-install', params: { str: str, idDet: data.idDet, idInst: data.idInst } } )
    }else{
        router.push( { name: 'scan-install', params: { str: str, idDet: data.idDet } } )
    }
}

// FUNCTION TRIGGER PAR RECUPSCAN POUR CODE BOUTEILLE
window.fillCodeBarre = function(str, data = {}) {
    if(str.indexOf('#id') > 0){
        str = str.split('#id')[1];
    }else if(str.indexOf('://bouteille/') > 0){
        str = str.split('/bouteille/')[1];
    }


    if(!window.app || !window.app.$children || window.app.$children.length === 0) {
        console.warn('Vue app non prête pour remplir le code barre');
        return;
    }

    if(data.type === 'bouteille') {
        const rootChild = window.app.$children[0];
        if(rootChild && rootChild.bouteille) {
            rootChild.bouteille.code = str
        }
    }else if(data.type === 'installation') {
        const rootChild = window.app.$children[0];
        if(rootChild && rootChild.installation) {
            rootChild.installation.nom = str
        }
    }
};

// FONCTION ARRONDIR
window.round = function (value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
};

const parentElement = document.querySelector('body');

parentElement.addEventListener('click', function(event) {
    const target = event.target.closest ? event.target.closest('span.question-info[title]') : null;
    if (target) {
        const title = target.querySelector('.title');
        if (!title) {
            const newTitle = document.createElement('span');
            newTitle.classList.add('title');
            newTitle.textContent = target.getAttribute('title');
            target.appendChild(newTitle);
        } else {
            title.remove();
        }
    }
});

window.isAppleDevice = function isAppleDevice() {
    return (
        (navigator.userAgent.toLowerCase().indexOf("ipad") > -1) ||
        (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) ||
        (navigator.userAgent.toLowerCase().indexOf("ipod") > -1)
    );
}


let searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
let forkUser = searchParams.get('forkUser');
if(forkUser !== null) {
    localforage.setItem('api-token', forkUser).then(() => {
        swal('Fork', 'Fork Réussi', 'success').then(
            () => {
                router.push({name: "init"})
            }
        )
    })
}




// WEBPACK FOOTER //
// ./src/js/main.js